import React from 'react';
import BottomSheet from '../BottomSheet';
import BadgeCard from './BadgeCard';

/**
 * "Vedi tutto" sheet: full grid of every badge in a category.
 * z-[1100] (above BottomNav); il dettaglio badge si apre sopra a z-[1200].
 */
function CategoryAllSheet({ label, badges, stats, earnedMap, selectedKey, onBadgeClick, onClose }) {
  if (!badges) return null;
  const unlocked = badges.filter((b) => earnedMap.has(b.key)).length;

  return (
    <BottomSheet
      onClose={onClose}
      zIndexClass="z-[1100]"
      footer={
        <button
          type="button"
          onClick={onClose}
          className="w-full py-3.5 bg-gray-100 text-gray-700 font-semibold rounded-2xl text-base"
        >
          Chiudi
        </button>
      }
    >
      <div className="flex items-center justify-between px-6 pt-1 pb-3">
        <h2 className="text-lg font-bold text-gray-900">{label}</h2>
        <span className="text-sm font-medium text-gray-400">
          {unlocked}/{badges.length}
        </span>
      </div>

      {/* pt-2 dà spazio agli overlay -top-1 (★/🔒) della prima riga */}
      <div className="grid grid-cols-3 gap-y-6 gap-x-2 justify-items-center px-6 pt-2 pb-2">
        {badges.map((b) => (
          <BadgeCard
            key={b.key}
            badge={b}
            stats={stats}
            earned={earnedMap.has(b.key)}
            earnedAt={earnedMap.get(b.key)}
            selected={selectedKey === b.key}
            onClick={() => onBadgeClick(b)}
          />
        ))}
      </div>
    </BottomSheet>
  );
}

export default CategoryAllSheet;
